export default {
    path: '/appCapabilitiesWecode',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'appCapabilitiesWecode',
    layout: 'inner', // outer 一级菜单 inner 二级菜单
    component: () => import('./index')
  };
  